/**
 * Configuração de cores e labels dos status de unidades.
 * Usado no mapa de vendas e em outros componentes que exibem status de unidades.
 */

import { STATUS_COLOR_PALETTE } from './statusColorPalette';

export const unitStatusColors = {
    available: STATUS_COLOR_PALETTE.green,
    sold: STATUS_COLOR_PALETTE.red,
    reserved: STATUS_COLOR_PALETTE.yellow,
    maintenance: STATUS_COLOR_PALETTE.orange,
    unavailable: STATUS_COLOR_PALETTE.grey,
};

export const unitStatusLabels = {
    available: 'Disponível',
    sold: 'Vendido',
    reserved: 'Reservado',
    maintenance: 'Em Manutenção',
    unavailable: 'Indisponível',
};

/**
 * Retorna a configuração completa (cor de fundo, cor do texto e label)
 * para um dado status de unidade.
 */
export const getUnitStatusConfig = (status) => {
    const color = unitStatusColors[status] || '#a0aec0';
    const label = unitStatusLabels[status] || status;

    // Determina a cor do texto com base no brilho do fundo
    const darkStatuses = ['available', 'sold', 'maintenance', 'unavailable'];
    const textColor = darkStatuses.includes(status) ? '#fff' : '#333';

    return { color, label, textColor };
};
